import { OpenInNew } from '@mui/icons-material';
import { formatTranslation } from 'intl';
import { NotificationTranslationKeys } from 'intl/keys';
import { IconButton, Tooltip } from '@mui/material';
import { HoverCardTranslationKeys } from 'components/common/hoverCardTranslationKeys';
import React from 'react';
import { useIntl } from 'react-intl';
import { useCurrentUserInProjectModel } from 'store/user';
import { isManagerOrAdmin } from 'shared/domain/role/isManagerOrAdmin';
import { iconButtonStyle } from './styles';

export const GoToUserIcon = ({
  userId,
}: {
  userId: string;
}): React.ReactElement => {
  const intl = useIntl();
  const submitter = useCurrentUserInProjectModel();

  const disabled = !isManagerOrAdmin(submitter.role);
  const tooltipTitle = disabled
    ? formatTranslation(intl, NotificationTranslationKeys.actionForbidden)
    : formatTranslation(intl, HoverCardTranslationKeys.OPEN_DETAILED_VIEW_USER,);

  return (
    <IconButton
      color='inherit'
      size='medium'
      disabled={disabled}
      sx={iconButtonStyle}
      onClick={() => {
        window.open(`/user/${userId}`, '_blank');
      }}
    >
      <Tooltip title={tooltipTitle}>
        <OpenInNew fontSize='small' />
      </Tooltip>
    </IconButton>
  );
};
